import type { Trip, TripWithItinerary, ItineraryRecord } from "../../shared/types";

async function req<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    ...init,
    headers: { "content-type": "application/json", ...(init?.headers || {}) },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const d = data as any;
    const parts = [d?.error || `Request failed (${res.status})`, d?.hint, d?.detail].filter(Boolean);
    throw new Error(parts.join(" — "));
  }
  return data as T;
}

export const api = {
  createTrip: (trip: Trip) =>
    req<{ trip: Trip }>("/api/trips", { method: "POST", body: JSON.stringify(trip) }),

  getTrip: (slug: string) => req<{ trip: TripWithItinerary }>(`/api/trips/${slug}`),

  updateTrip: (slug: string, trip: Trip) =>
    req<{ trip: Trip }>(`/api/trips/${slug}`, { method: "PUT", body: JSON.stringify(trip) }),

  generate: (slug: string) =>
    req<{ itinerary: ItineraryRecord }>(`/api/trips/${slug}/itinerary`, { method: "POST" }),

  finalize: (slug: string, version?: number) =>
    req<{ ok: boolean; version: number }>(`/api/trips/${slug}/finalize`, {
      method: "POST",
      body: JSON.stringify({ version }),
    }),

  insights: (owner: string) =>
    req<{ insights: any }>(`/api/insights?owner=${encodeURIComponent(owner)}`),
};
